import { render } from "./BotoxEtc.vue?vue&type=template&id=1ab0be9e"
import script from "./BotoxEtc.vue?vue&type=script&lang=js"
export * from "./BotoxEtc.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__